
<div class="app-page" style="display: flex; flex-wrap: wrap;">
  @for (t of teams; track t) {
    <div style="min-width: 390px;">
      <app-team-card [Team]="t" [Positions]="this.positions" (updated)="ngOnInit();">
      </app-team-card>
    </div>
  }
</div>
